import request from '@/utils/request'
// 根据用户编号回显网吧信息
export function SearchCustomer(data) {
    return request({
        url:'/netbar/api/customer_management/v1/list',
        method:'post',
        data
    })
}
// 根据场所名称搜索
export function HistorySearchCustomer(data) {
    return request({
        url:'/netbar/api/customer_management/v1/search',
        method:'post',
        data
    })
}
// 用户历史搜索
export function HistorySearchListCustomer(data) {
    return request({
        url:'/netbar/api/customer_management/v1/history_information',
        method:'post',
        data
    })
}
// 删除历史记录
export function DelHistorySearchListCustomer(data) {
    return request({
        url:'/netbar/api/customer_management/v1/del_history_information',
        method:'post',
        data
    })
}
// 获取详情
export function CustomerDetails(data) {
    return request({
        url:'/netbar/api/customer_management/v1/getDetail',
        method:'post',
        data
    })
}
// 保存备注
export function CustomerNote(data) {
    return request({
        url:'/netbar/api/customer_management/v1/add_remark',
        method:'post',
        data
    })
}
// 用户管理
export function CustomerUser(data) {
    return request({
        url:'/netbar/api/customer_management/v1/belong_netbar_user',
        method:'post',
        data
    })
}
// 设置用户管理员
export function SetCustomerUser(data) {
    return request({
        url:'/netbar/api/customer_management/v1/setAdmin',
        method:'post',
        data
    })
}

